<div class="" style="margin-bottom:15px !important">
    <!--latest news-->
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">Training</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="padding: 20px !important; border-top-right-radius: 0px; border-top-left-radius: 0px">
        <div class="row small-section-content">
            <div class="col-xl-12 text-center empty" style="padding: 20px 0 0 0;">
                <i class="fa fa-book" style="font-size: 60px; opacity: .1;"></i>
                <p style="text-align: left;padding: 10px;">We offer training opportunities to enhance and broaden GIS skills, to keep those skills current with the latest technology and software developments.</p>
                <p style="text-align: left;padding: 10px;">Training courses are offered at the gistec Training Center or on-site at customer premises.</p>
            </div>
        </div>
        <div class="col-xl-12 text-center" style="margin-top:10px">
            <button style="height:40px" (click)="OpenRequest()" class="btn btn mygistec-btn-outline">training request</button>
        </div>
    </div>

</div>
